import React, { useEffect, useReducer } from 'react';
import { ToastContainer } from 'react-toastify';
import cx from 'classnames';
import StateContext from './context/StateContext';
import Home from './views/Home';
import Header from './views/Header';
import Footer from './views/Footer';
import useWindowSize from './hooks/useWindowResize';
import { reducer } from './reducers/reducer';
import { updateIsMobileState } from './reducers/actions';
import { initialState } from './utils/initialStateContants';
import 'react-toastify/dist/ReactToastify.css';
import style from './App.module.scss';

const App = ({ showFooter = true }) => {
	const [state, dispatch] = useReducer(reducer, initialState);
	const windowSize = useWindowSize();

	useEffect(() => {
		updateIsMobileState({ payload: windowSize?.width <= 768, dispatch });
	}, [windowSize?.width]);

	return (
		<StateContext.Provider value={{ state, dispatch }}>
			<ToastContainer />
			<div className={cx({ [style.hasFooter]: showFooter })}>
				<Header />
				<Home />
			</div>
			{showFooter && <Footer/>}
		</StateContext.Provider>
	);
};

export default App;
